import { AsyncPipe } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Item } from '../../../../../../../../app/core/shared/item.model';
import { MetadataValue } from '../../../../../../../../app/core/shared/metadata.models';
import { MetadataValuesComponent } from '../../../../../../../../app/item-page/field-components/metadata-values/metadata-values.component';

@Component({
  selector: 'ds-localized-generic-item-page-field',
  templateUrl: './localized-generic-item-page-field.component.html',
  standalone: true,
  imports: [MetadataValuesComponent, AsyncPipe],
})
/**
 * Renders metadata values (e.g. multilingual dc.description.abstract) filtered to only the
 * value matching the currently active interface language, falling back to the first available
 * value when no value matches that language.
 */
export class LocalizedGenericItemPageFieldComponent {

  /**
   * The item to display metadata for
   */
  @Input() item: Item;

  /**
   * Separator string between multiple values of the metadata fields defined
   */
  @Input() separator = '<br/>';

  /**
   * Fields (schema.element.qualifier) used to render their values.
   */
  @Input() fields: string[];

  /**
   * Label i18n key for the rendered metadata
   */
  @Input() label: string;

  /**
   * Whether the {@link MarkdownDirective} should be used to render this metadata.
   */
  @Input() enableMarkdown = false;

  constructor(
    protected translateService: TranslateService,
  ) {
  }

  get filteredValues(): MetadataValue[] {
    const allValues = this.item?.allMetadata(this.fields) ?? [];
    const currentLang = this.translateService.currentLang;
    const matchingLang = allValues.filter((value) => value.language === currentLang);
    return matchingLang.length > 0 ? matchingLang : allValues;
  }

}
